module.exports = __webpack_public_path__ + "20618d6ecde62cf7617a8191610a3c90.png";